import { actions } from './constants'

import { factoryReducer, flattenStringMap } from '../../../../reducers/utils'

const initialState = {
  list: [],
  activeTab: '',
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.INITIALIZE: {
      return {
        ...state,
        list: payload.tabs,
        activeTab: payload.activeTab,
      }
    }
    case actions.CHOOSE_TAB: {
      return {
        ...state,
        activeTab: payload.name,
      }
    }
    default: {
      return state
    }
  }
}

export default factoryReducer(
  {
    registerType: actions.INITIALIZE,
  },
  flattenStringMap(actions),
  reducer,
  (meta) => meta.name,
)
